// Minimal DOM helpers. Not a framework, and deliberately not growing into one.

export function el<K extends keyof HTMLElementTagNameMap>(
  tag: K,
  attrs: Record<string, string> = {},
  children: (Node | string)[] = [],
): HTMLElementTagNameMap[K] {
  const node = document.createElement(tag);
  for (const [k, v] of Object.entries(attrs)) node.setAttribute(k, v);
  node.append(...children);
  return node;
}

export function button(label: string, onClick: () => void, variant = ''): HTMLButtonElement {
  const b = el('button', variant ? { class: variant } : {}, [label]);
  b.addEventListener('click', onClick);
  return b;
}

/** Sets text only when it changed, so a per-second tick does not thrash. */
export function setText(node: HTMLElement, text: string): void {
  if (node.textContent !== text) node.textContent = text;
}

/**
 * Seconds remaining until a wall-clock UnixMilli deadline.
 *
 * Derived from `deadline - now` on every call rather than decremented, which
 * is what makes a suspended WebView resume on the right number. Clamped at 0:
 * a negative countdown means the server has already moved on and is about to
 * tell us.
 */
export function secondsUntil(deadlineMs: number | null, now = Date.now()): number | null {
  if (deadlineMs === null) return null;
  return Math.max(0, Math.ceil((deadlineMs - now) / 1000));
}

/** "01" -> a stable colour, so a player looks the same in every list. */
export function avatarColor(avatar: string): string {
  const palette = ['#3ddc84', '#5aa9ff', '#ffb454', '#ff6b9d', '#b58cff', '#4fd1c5'];
  let hash = 0;
  for (const ch of avatar) hash = (hash * 31 + ch.charCodeAt(0)) >>> 0;
  return palette[hash % palette.length]!;
}

export function initials(username: string): string {
  const trimmed = username.trim();
  return trimmed ? trimmed.slice(0, 2).toUpperCase() : '??';
}
